import React, { ReactNode } from "react";
import { Box } from "@mui/material";
import { InformationToolTipContent, Typography } from "@coolset/cs-ui";

export const FormInput = (props: FormInputProps) => {
  const { subtitle, title, isOptional, fieldInput, tooltipTitle } = props;
  return (
    <div className="module-form-input">
      <Typography variant="h5" mb={1} color="secondary" className="_d-flex-ali-center-xs-gap">
        {title}
        {!isOptional && "* "}
        {!isOptional && (
          <Box component="span" color="text.tertiary">
            (required)
          </Box>
        )}
        {tooltipTitle && <InformationToolTipContent tooltipTitle={tooltipTitle} />}
      </Typography>
      {subtitle && (
        <Typography variant="body2" color="text.secondary">
          {subtitle}
        </Typography>
      )}
      {fieldInput}
    </div>
  );
};

interface FormInputProps {
  subtitle?: string;
  title: string;
  isOptional?: boolean;
  tooltipTitle?: string;
  fieldInput: ReactNode;
}
